import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';

const LazyImage = (
    {
        src = '',
        alt = '',
        title = '',
        onClick = () => {},
        className = '',
        style = {},
        width = null,
        height = null
    }
) => {

    const { ref, inView } = useInView({
        triggerOnce: true
    });

    if (src && src.substring(0, 4) !== 'http' && src.substring(0, 4) !== 'data') {
        src = `${window.rootMarketingCdn}${src.replace(/^\/+/, '')}`;
    }
    style = {
        ...{
            display: 'block',
            maxWidth: '100%'
        },
        ...style
    };

    const handleClick = (e) => {
        onClick(e);
    };

    return (
        <img
            src={inView ? src : `data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7`}
            alt={alt}
            title={title}
            width={typeof width === 'number' ? `${width}px` : width}
            height={typeof height === 'number' ? `${height}px` : height}
            style={style}
            className={className}
            ref={ref}
            onClick={handleClick}
        />
    );
};

LazyImage.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object
};

export default LazyImage;